import React from 'react'

import { IProps } from './index'
import { mq } from 'marketing-site/src/library/utils'
import { Text } from 'marketing-site/src/library/elements/Text'
import { RichText } from 'marketing-site/src/mvp/library/elements/RichText'

export const IconGridItem: React.FC<IProps> = ({ icon, title, subhead, cta }) => {
  return (
    <>
      <div className="icon-grid-item" data-testid="icon-grid-item">
        <div className="icon-grid-item__icon">{icon}</div>
        <h3 className="icon-grid-item__title">
          <Text size="heading-5">{title}</Text>
        </h3>
        <div className="icon-grid-item__subhead">
          <Text size="body">
            <RichText document={subhead} />
          </Text>
        </div>
        {cta && <div className="icon-grid-item__cta">{cta}</div>}
      </div>

      <style jsx>
        {`
          .icon-grid-item {
            &__icon {
              display: flex;
              width: 2rem;
            }

            &__title {
              margin-top: 1.25rem;
            }

            &__subhead {
              margin-top: 0.25rem;
            }

            &__cta {
              margin-top: 1.25rem;
            }
          }

          @media (${mq.tablet}) {
            .icon-grid-item {
              &__title {
                margin-top: 1.5rem;
              }

              &__cta {
                margin-top: 1.5rem;
              }
            }
          }
        `}
      </style>
    </>
  )
}
